import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getOrganisationDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  managementTeamPageContent: [
    {
      fieldName: "Order Sequence",
      fieldValue: "field_organisation_order_sequenc",
      className: "col-span-6",
      type: "text",
      name: "field_organisation_order_sequenc",
      formType: "number",
      label: "Order Sequence",
      placeholder: "Select Order Sequence",
      validation: { required: "Order Sequence is required" },
    },
    {
      fieldName: "Image",
      fieldValue: "field_organisation_image",
      className: "col-span-6",
      type: "image",
      name: "field_organisation_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_title_name_ms",
      className: "col-span-6",
      type: "text",
      name: "field_title_name_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_title_name_zh",
      className: "col-span-6",
      type: "text",
      name: "field_title_name_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Designation (EN)",
      fieldValue: "field_designation_en",
      className: "col-span-6",
      type: "text",
      name: "field_designation_en",
      formType: "input",
      label: "Designation (EN)",
      placeholder: "Enter Designation (EN)",
      validation: { required: "Designation (EN) is required" },
    },
    {
      fieldName: "Designation (MS)",
      fieldValue: "field_designation_ms",
      className: "col-span-6",
      type: "text",
      name: "field_designation_ms",
      formType: "input",
      label: "Designation (MS)",
      placeholder: "Enter Designation (MS)",
      // validation: { required: "Designation (MS) is required" },
    },
    {
      fieldName: "Designation (ZH)",
      fieldValue: "field_designation_zh",
      className: "col-span-6",
      type: "text",
      name: "field_designation_zh",
      formType: "input",
      label: "Designation (ZH)",
      placeholder: "Enter Designation (ZH)",
      // validation: { required: "Designation (ZH) is required" },
    },
    // {
    //   fieldName: "Link (EN)",
    //   fieldValue: "field_link_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_link_en",
    //   formType: "input",
    //   label: "Link (EN)",
    //   placeholder: "Enter Link (EN)",
    //   validation: { required: "Link (EN) is required" },
    // },
    // {
    //   fieldName: "Link (MS)",
    //   fieldValue: "field_link_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_link_ms",
    //   formType: "input",
    //   label: "Link (MS)",
    //   placeholder: "Enter Link (MS)",
    //   // validation: { required: "Link (MS) is required" },
    // },
    // {
    //   fieldName: "Link (ZH)",
    //   fieldValue: "field_link_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_link_zh",
    //   formType: "input",
    //   label: "Link (ZH)",
    //   placeholder: "Enter Link (ZH)",
    //   // validation: { required: "Link (ZH) is required" },
    // },
    // {
    //   fieldName: "Page (EN)",
    //   fieldValue: "field_page_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_en",
    //   formType: "input",
    //   label: "Page (EN)",
    //   placeholder: "Enter Page (EN)",
    //   validation: { required: "Page (EN) is required" },
    // },
    // {
    //   fieldName: "Page (MS)",
    //   fieldValue: "field_page_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_ms",
    //   formType: "input",
    //   label: "Page (MS)",
    //   placeholder: "Enter Page (MS)",
    //   // validation: { required: "Page (MS) is required" },
    // },
    // {
    //   fieldName: "Page (ZH)",
    //   fieldValue: "field_page_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_zh",
    //   formType: "input",
    //   label: "Page (ZH)",
    //   placeholder: "Enter Page (ZH)",
    //   // validation: { required: "Page (ZH) is required" },
    // },
    {
      fieldName: "Categories (EN)",
      fieldValue: "field_categories",
      className: "col-span-6",
      type: "select",
      name: "field_categories",
      formType: "select",
      label: "Categories (EN)",
      placeholder: "Enter Categories (EN)",
      validation: { required: "Categories (EN) is required" },
      options: [
        {
          value: "group-level",
          label: "Group Level",
        },
        {
          value: "subsidiaries",
          label: "Subsidiaries",
        },
      ],
    },
    {
      fieldName: "Categories (MS)",
      fieldValue: "field_categories_ms",
      className: "col-span-6",
      type: "select",
      name: "field_categories_ms",
      formType: "select",
      label: "Categories (MS)",
      placeholder: "Enter Categories (MS)",
      // validation: { required: "Categories (MS) is required" },
      options: [
        {
          value: "group-level",
          label: "Group Level",
        },
        {
          value: "subsidiaries",
          label: "Subsidiaries",
        },
      ],
    },
    {
      fieldName: "Categories (ZH)",
      fieldValue: "field_categories_zh",
      className: "col-span-6",
      type: "select",
      name: "field_categories_zh",
      formType: "select",
      label: "Categories (ZH)",
      placeholder: "Enter Categories (ZH)",
      // validation: { required: "Categories (ZH) is required" },
      options: [
        {
          value: "group-level",
          label: "Group Level",
        },
        {
          value: "subsidiaries",
          label: "Subsidiaries",
        },
      ],
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "field_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_description_en",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "field_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_description_ms",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "field_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_description_zh",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  boardOfDirectorsPageContent: [
    {
      fieldName: "Order Sequence",
      fieldValue: "field_organisation_order_sequenc",
      className: "col-span-6",
      type: "text",
      name: "field_organisation_order_sequenc",
      formType: "number",
      label: "Order Sequence",
      placeholder: "Select Order Sequence",
      validation: { required: "Order Sequence is required" },
    },
    {
      fieldName: "Image",
      fieldValue: "field_organisation_image",
      className: "col-span-6",
      type: "image",
      name: "field_organisation_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_title_name_ms",
      className: "col-span-6",
      type: "text",
      name: "field_title_name_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_title_name_zh",
      className: "col-span-6",
      type: "text",
      name: "field_title_name_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Designation (EN)",
      fieldValue: "field_designation_en",
      className: "col-span-6",
      type: "text",
      name: "field_designation_en",
      formType: "input",
      label: "Designation (EN)",
      placeholder: "Enter Designation (EN)",
      validation: { required: "Designation (EN) is required" },
    },
    {
      fieldName: "Designation (MS)",
      fieldValue: "field_designation_ms",
      className: "col-span-6",
      type: "text",
      name: "field_designation_ms",
      formType: "input",
      label: "Designation (MS)",
      placeholder: "Enter Designation (MS)",
      // validation: { required: "Designation (MS) is required" },
    },
    {
      fieldName: "Designation (ZH)",
      fieldValue: "field_designation_zh",
      className: "col-span-6",
      type: "text",
      name: "field_designation_zh",
      formType: "input",
      label: "Designation (ZH)",
      placeholder: "Enter Designation (ZH)",
      // validation: { required: "Designation (ZH) is required" },
    },
    // {
    //   fieldName: "Link (EN)",
    //   fieldValue: "field_link_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_link_en",
    //   formType: "input",
    //   label: "Link (EN)",
    //   placeholder: "Enter Link (EN)",
    //   validation: { required: "Link (EN) is required" },
    // },
    // {
    //   fieldName: "Link (MS)",
    //   fieldValue: "field_link_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_link_ms",
    //   formType: "input",
    //   label: "Link (MS)",
    //   placeholder: "Enter Link (MS)",
    //   // validation: { required: "Link (MS) is required" },
    // },
    // {
    //   fieldName: "Link (ZH)",
    //   fieldValue: "field_link_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_link_zh",
    //   formType: "input",
    //   label: "Link (ZH)",
    //   placeholder: "Enter Link (ZH)",
    //   // validation: { required: "Link (ZH) is required" },
    // },
    // {
    //   fieldName: "Page (EN)",
    //   fieldValue: "field_page_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_en",
    //   formType: "input",
    //   label: "Page (EN)",
    //   placeholder: "Enter Page (EN)",
    //   validation: { required: "Page (EN) is required" },
    // },
    // {
    //   fieldName: "Page (MS)",
    //   fieldValue: "field_page_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_ms",
    //   formType: "input",
    //   label: "Page (MS)",
    //   placeholder: "Enter Page (MS)",
    //   // validation: { required: "Page (MS) is required" },
    // },
    // {
    //   fieldName: "Page (ZH)",
    //   fieldValue: "field_page_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_zh",
    //   formType: "input",
    //   label: "Page (ZH)",
    //   placeholder: "Enter Page (ZH)",
    //   // validation: { required: "Page (ZH) is required" },
    // },
    // {
    //   fieldName: "Categories (EN)",
    //   fieldValue: "field_categories",
    //   className: "col-span-6",
    //   type: "select",
    //   name: "field_categories",
    //   formType: "select",
    //   label: "Categories (EN)",
    //   placeholder: "Enter Categories (EN)",
    //   validation: { required: "Categories (EN) is required" },
    //   options: [
    //     {
    //       value: "group-level",
    //       label: "Group Level"
    //     },
    //     {
    //       value: "subsidiaries",
    //       label: "Subsidiaries"
    //     },
    //   ]
    // },
    // {
    //   fieldName: "Categories (MS)",
    //   fieldValue: "field_categories_ms",
    //   className: "col-span-6",
    //   type: "select",
    //   name: "field_categories_ms",
    //   formType: "select",
    //   label: "Categories (MS)",
    //   placeholder: "Enter Categories (MS)",
    //   // validation: { required: "Categories (MS) is required" },
    //   options: [
    //     {
    //       value: "group-level",
    //       label: "Group Level"
    //     },
    //     {
    //       value: "subsidiaries",
    //       label: "Subsidiaries"
    //     },
    //   ]
    // },
    // {
    //   fieldName: "Categories (ZH)",
    //   fieldValue: "field_categories_zh",
    //   className: "col-span-6",
    //   type: "select",
    //   name: "field_categories_zh",
    //   formType: "select",
    //   label: "Categories (ZH)",
    //   placeholder: "Enter Categories (ZH)",
    //   // validation: { required: "Categories (ZH) is required" },
    //   options: [
    //     {
    //       value: "group-level",
    //       label: "Group Level"
    //     },
    //     {
    //       value: "subsidiaries",
    //       label: "Subsidiaries"
    //     },
    //   ]
    // },
    {
      fieldName: "Description (EN)",
      fieldValue: "field_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_description_en",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "field_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_description_ms",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "field_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_description_zh",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  companyStructurePageContent: [
    {
      fieldName: "Image",
      fieldValue: "data.image",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "image",
      name: "field_content_english_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "data.text",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_description",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Next Page Name (EN)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_next_page_name",
      formType: "input",
      label: "Next Page Name (EN)",
      placeholder: "Enter Next Page Name (EN)",
      validation: { required: "Next Page Name (EN) is required" },
    },
    {
      fieldName: "Next Page Link (EN)",
      fieldValue: "data.nextPage.link",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_next_page_link",
      formType: "input",
      label: "Next Page Link (EN)",
      placeholder: "Enter content Next Page Link (EN)",
      validation: { required: "Next Page Link (EN) is required" },
    },
    // {
    //   fieldName: "Image (MS)",
    //   fieldValue: "data.image",
    //   parseField: "field_content_malay",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_content_malay_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Image (MS)",
    //   placeholder: "Select Image (MS)",
    //   // validation: { required: "Image (MS) is required" },
    // },
    {
      fieldName: "Description (MS)",
      fieldValue: "data.text",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_description",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: {},
    },
    {
      fieldName: "Next Page Name (MS)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_next_page_name",
      formType: "input",
      label: "Next Page Name (MS)",
      placeholder: "Enter Next Page Name (MS)",
      // validation: {},
    },
    {
      fieldName: "Next Page Link (MS)",
      fieldValue: "data.nextPage.link",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_next_page_link",
      formType: "input",
      label: "Next Page Link (MS)",
      placeholder: "Enter Next Page Link (MS)",
      // validation: {},
    },
    // {
    //   fieldName: "Image (ZH)",
    //   fieldValue: "data.image",
    //   parseField: "field_content_mandarin",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_content_mandarin_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Image (ZH)",
    //   placeholder: "Select Image (ZH)",
    //   // validation: { required: "Image (EN) is required" },
    // },
    {
      fieldName: "Description (ZH)",
      fieldValue: "data.text",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_description",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: {},
    },
    {
      fieldName: "Next Page Name (ZH)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_next_page_name",
      formType: "input",
      label: "Next Page Name (ZH)",
      placeholder: "Enter Next Page Name (ZH)",
      // validation: {},
    },
    {
      fieldName: "Next Page Link (ZH)",
      fieldValue: "data.nextPage.link",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_next_page_link",
      formType: "input",
      label: "Next Page Link (ZH)",
      placeholder: "Enter Next Page Link (ZH)",
      // validation: {},
    },
  ],
  managementTeamPageHeading: [
    {
      fieldName: "Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Banner Image",
      placeholder: "Enter Banner Image URL",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (EN)",
      validation: { required: "Page Title (EN) is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (MS)",
      // validation: { required: "Page Title (MS) is required" },
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (ZH)",
      // validation: { required: "Page Title (ZH) is required" },
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (EN)",
      // validation: { required: "Page Description (EN) is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (MS)",
      // validation: { required: "Page Description (MS) is required" },
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (ZH)",
      // validation: { required: "Page Description (ZH) is required" },
    },
    // {
    //   fieldName: "Metadata Image",
    //   fieldValue: "field_page_metadata_image",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_page_metadata_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Metadata Image",
    //   placeholder: "Enter Metadata Image URL",
    //   validation: { required: "Metadata Image is required" },
    // },
    // {
    //   fieldName: "Metadata Title (EN)",
    //   fieldValue: "field_page_metadata_title_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_en",
    //   formType: "input",
    //   label: "Metadata Title (EN)",
    //   placeholder: "Enter Metadata Title (EN)",
    //   validation: { required: "Metadata Title (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (MS)",
    //   fieldValue: "field_page_metadata_title_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_ms",
    //   formType: "input",
    //   label: "Metadata Title (MS)",
    //   placeholder: "Enter Metadata Title (MS)",
    //   // validation: { required: "Metadata Title (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (ZH)",
    //   fieldValue: "field_page_metadata_title_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_zh",
    //   formType: "input",
    //   label: "Metadata Title (ZH)",
    //   placeholder: "Enter Metadata Title (ZH)",
    //   // validation: { required: "Metadata Title (ZH) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (EN)",
    //   fieldValue: "field_page_metadata_desc_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_en",
    //   formType: "richText",
    //   label: "Metadata Description (EN)",
    //   placeholder: "Enter Metadata Description (EN)",
    //   validation: { required: "Metadata Description (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (MS)",
    //   fieldValue: "field_page_metadata_desc_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_ms",
    //   formType: "richText",
    //   label: "Metadata Description (MS)",
    //   placeholder: "Enter Metadata Description (MS)",
    //   // validation: { required: "Metadata Description (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (ZH)",
    //   fieldValue: "field_page_metadata_desc_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_zh",
    //   formType: "richText",
    //   label: "Metadata Description (ZH)",
    //   placeholder: "Enter Metadata Description (ZH)",
    //   // validation: { required: "Metadata Description (ZH) is required" },
    // },
  ],
  boardOfDirectorsPageHeading: [
    {
      fieldName: "Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Banner Image",
      placeholder: "Enter Banner Image URL",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (EN)",
      validation: { required: "Page Title (EN) is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (MS)",
      // validation: { required: "Page Title (MS) is required" },
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (ZH)",
      // validation: { required: "Page Title (ZH) is required" },
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (EN)",
      // validation: { required: "Page Description (EN) is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (MS)",
      // validation: { required: "Page Description (MS) is required" },
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (ZH)",
      // validation: { required: "Page Description (ZH) is required" },
    },
    // {
    //   fieldName: "Metadata Image",
    //   fieldValue: "field_page_metadata_image",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_page_metadata_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Metadata Image",
    //   placeholder: "Enter Metadata Image URL",
    //   validation: { required: "Metadata Image is required" },
    // },
    // {
    //   fieldName: "Metadata Title (EN)",
    //   fieldValue: "field_page_metadata_title_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_en",
    //   formType: "input",
    //   label: "Metadata Title (EN)",
    //   placeholder: "Enter Metadata Title (EN)",
    //   validation: { required: "Metadata Title (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (MS)",
    //   fieldValue: "field_page_metadata_title_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_ms",
    //   formType: "input",
    //   label: "Metadata Title (MS)",
    //   placeholder: "Enter Metadata Title (MS)",
    //   // validation: { required: "Metadata Title (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (ZH)",
    //   fieldValue: "field_page_metadata_title_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_zh",
    //   formType: "input",
    //   label: "Metadata Title (ZH)",
    //   placeholder: "Enter Metadata Title (ZH)",
    //   // validation: { required: "Metadata Title (ZH) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (EN)",
    //   fieldValue: "field_page_metadata_desc_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_en",
    //   formType: "richText",
    //   label: "Metadata Description (EN)",
    //   placeholder: "Enter Metadata Description (EN)",
    //   validation: { required: "Metadata Description (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (MS)",
    //   fieldValue: "field_page_metadata_desc_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_ms",
    //   formType: "richText",
    //   label: "Metadata Description (MS)",
    //   placeholder: "Enter Metadata Description (MS)",
    //   // validation: { required: "Metadata Description (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (ZH)",
    //   fieldValue: "field_page_metadata_desc_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_zh",
    //   formType: "richText",
    //   label: "Metadata Description (ZH)",
    //   placeholder: "Enter Metadata Description (ZH)",
    //   // validation: { required: "Metadata Description (ZH) is required" },
    // },
  ],
  companyStructurePageHeading: [
    {
      fieldName: "Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Banner Image",
      placeholder: "Enter Banner Image URL",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (EN)",
      validation: { required: "Page Title (EN) is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (MS)",
      // validation: { required: "Page Title (MS) is required" },
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (ZH)",
      // validation: { required: "Page Title (ZH) is required" },
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (EN)",
      // validation: { required: "Page Description (EN) is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (MS)",
      // validation: { required: "Page Description (MS) is required" },
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (ZH)",
      // validation: { required: "Page Description (ZH) is required" },
    },
    // {
    //   fieldName: "Metadata Image",
    //   fieldValue: "field_page_metadata_image",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_page_metadata_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Metadata Image",
    //   placeholder: "Enter Metadata Image URL",
    //   validation: { required: "Metadata Image is required" },
    // },
    // {
    //   fieldName: "Metadata Title (EN)",
    //   fieldValue: "field_page_metadata_title_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_en",
    //   formType: "input",
    //   label: "Metadata Title (EN)",
    //   placeholder: "Enter Metadata Title (EN)",
    //   validation: { required: "Metadata Title (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (MS)",
    //   fieldValue: "field_page_metadata_title_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_ms",
    //   formType: "input",
    //   label: "Metadata Title (MS)",
    //   placeholder: "Enter Metadata Title (MS)",
    //   // validation: { required: "Metadata Title (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (ZH)",
    //   fieldValue: "field_page_metadata_title_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_zh",
    //   formType: "input",
    //   label: "Metadata Title (ZH)",
    //   placeholder: "Enter Metadata Title (ZH)",
    //   // validation: { required: "Metadata Title (ZH) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (EN)",
    //   fieldValue: "field_page_metadata_desc_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_en",
    //   formType: "richText",
    //   label: "Metadata Description (EN)",
    //   placeholder: "Enter Metadata Description (EN)",
    //   validation: { required: "Metadata Description (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (MS)",
    //   fieldValue: "field_page_metadata_desc_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_ms",
    //   formType: "richText",
    //   label: "Metadata Description (MS)",
    //   placeholder: "Enter Metadata Description (MS)",
    //   // validation: { required: "Metadata Description (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (ZH)",
    //   fieldValue: "field_page_metadata_desc_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_zh",
    //   formType: "richText",
    //   label: "Metadata Description (ZH)",
    //   placeholder: "Enter Metadata Description (ZH)",
    //   // validation: { required: "Metadata Description (ZH) is required" },
    // },
  ],
  boardOfDirectorsNextPage: [
  {
    fieldName: "Next Page Name (EN)",
    fieldValue: "data.nextPage.name",
    parseField: "field_content_english",
    className: "col-span-6",
    type: "content",
    name: "field_content_english_data_nextPage_name", // ✅ underscore instead of dot
    formType: "input",
    label: "Next Page Name (EN)",
    placeholder: "Enter content for Next Page Name (EN)",
    validation: { required: "Content for Next Page Name (EN) is required" },
  },
  {
    fieldName: "Next Page Name (MS)",
    fieldValue: "data.nextPage.name",
    parseField: "field_content_malay",
    className: "col-span-6",
    type: "content",
    name: "field_content_malay_data_nextPage_name", // ✅ underscore
    formType: "input",
    label: "Next Page Name (MS)",
    placeholder: "Enter content for Next Page Name (MS)",
    // validation: { required: "Content for Next Page Name (MS) is required" },
  },
  {
    fieldName: "Next Page Name (ZH)",
    fieldValue: "data.nextPage.name",
    parseField: "field_content_mandarin",
    className: "col-span-6",
    type: "content",
    name: "field_content_mandarin_data_nextPage_name", // ✅ underscore
    formType: "input",
    label: "Next Page Name (ZH)",
    placeholder: "Enter content for Next Page Name (ZH)",
    // validation: { required: "Content for Next Page Name (ZH) is required" },
  },
  {
    fieldName: "Next Page Link",
    fieldValue: "data.nextPage.link",
    parseField: "field_content_english",
    className: "col-span-6",
    type: "content",
    name: "field_content_english_data_nextPage_link", // ✅ underscore
    formType: "input",
    label: "Next Page Link",
    placeholder: "Enter content for Next Page Link",
    validation: {
      required: "Content for Next Page Link is required",
      validate: (value: string) => {
        const trimmed = value.trim();
        if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
        if (["http://", "https://", "www."].some((p) => trimmed.includes(p))) {
          return "Looks like an external link. Please use an in-app page link, such as /example";
        }
        return true;
      },
    },
  },
],
 managementNextPage: [
  {
    fieldName: "Next Page Name (EN)",
    fieldValue: "data.nextPage.name",
    parseField: "field_content_english",
    className: "col-span-6",
    type: "content",
    name: "field_content_english_data_nextPage_name", 
    formType: "input",
    label: "Next Page Name (EN)",
    placeholder: "Enter content for Next Page Name (EN)",
    validation: { required: "Content for Next Page Name (EN) is required" },
  },
  {
    fieldName: "Next Page Name (MS)",
    fieldValue: "data.nextPage.name",
    parseField: "field_content_malay",
    className: "col-span-6",
    type: "content",
    name: "field_content_malay_data_nextPage_name", // ✅ underscore
    formType: "input",
    label: "Next Page Name (MS)",
    placeholder: "Enter content for Next Page Name (MS)",
    // validation: { required: "Content for Next Page Name (MS) is required" },
  },
  {
    fieldName: "Next Page Name (ZH)",
    fieldValue: "data.nextPage.name",
    parseField: "field_content_mandarin",
    className: "col-span-6",
    type: "content",
    name: "field_content_mandarin_data_nextPage_name", // ✅ underscore
    formType: "input",
    label: "Next Page Name (ZH)",
    placeholder: "Enter content for Next Page Name (ZH)",
    // validation: { required: "Content for Next Page Name (ZH) is required" },
  },
  {
    fieldName: "Next Page Link",
    fieldValue: "data.nextPage.link",
    parseField: "field_content_english",
    className: "col-span-6",
    type: "content",
    name: "field_content_english_data_nextPage_link", // ✅ underscore
    formType: "input",
    label: "Next Page Link",
    placeholder: "Enter content for Next Page Link",
    validation: {
      required: "Content for Next Page Link is required",
      validate: (value: string) => {
        const trimmed = value.trim();
        if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
        if (["http://", "https://", "www."].some((p) => trimmed.includes(p))) {
          return "Looks like an external link. Please use an in-app page link, such as /example";
        }
        return true;
      },
    },
  },
]

}